import { Link, RouteProps, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { NotificationHandle, useNotification } from '@idk-web/core-ui';
import { ServiceType } from '@idk-web/api';
import { portalLoginStatus } from '@/state/portalAuth';
import { SentryRoute } from '@/sentry';
import { useEventListener } from '@/hooks/portal/ws/useEventListener';
import { useCompany } from '@/hooks/portal/useCompany';
import { DEFAULT_NOTIFICATION_AUTO_HIDE_MS } from '@/config';
import routes from '@/components/portal/routes';

export type EventAwareRouteProps = RouteProps;

const EventAwareRoute: FC<EventAwareRouteProps> = ({ ...props }) => {
  const { t } = useTranslation();
  const company = useCompany();
  const notification = useNotification();
  const loginStatus = useAtomValue(portalLoginStatus);
  const location = useLocation();

  useEventListener(
    'SAFEMAIL_MESSAGE_RECEIVED',
    () => {
      if (company.services.some((s) => s.type === ServiceType.SAFEMAIL)) {
        const isOnInboxPage = location.pathname.startsWith(
          routes.safemailInbox,
        );
        const duration = isOnInboxPage
          ? DEFAULT_NOTIFICATION_AUTO_HIDE_MS
          : undefined;

        let handle: NotificationHandle | null = null;
        const content = (
          <>
            {t('portal.notifications.safemail_message_received')}{' '}
            <Link to={routes.safemailInbox} onClick={() => handle?.close()}>
              {t('portal.notifications.safemail_message_received_view')}
            </Link>
          </>
        );
        handle = notification.show(content, 'success', duration);
      }
    },
    [t, loginStatus, company, location],
  );

  return <SentryRoute {...props} />;
};

export default EventAwareRoute;
